import theme from '../../theme';

export type Theme = typeof theme;

export const getTheme = (): Theme => theme;

export default { getTheme };
